var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-other-info"},[_c('div',{staticClass:"container"},[_c('live-popularity',{staticClass:"popularity",attrs:{"data":_vm.popularityData,"liveState":_vm.liveState,"liveTime":_vm.liveTime}}),_c('live-bullet-chat',{staticClass:"bullet-chat",attrs:{"list":_vm.bulletChatList,"liveState":_vm.liveState}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }